import { fetchWithTimeout, handleResponse } from "./BaseAPI";
import { trackPromise } from "react-promise-tracker";
import { getAccessToken } from "context/AuthContext";
import User from "context/User";

const baseUrlAPI = process.env.REACT_APP_U_API_URL;

async function handleAbuseResponse(response) {
  const result = await handleResponse(response);
  if (result && result.cod && !String(result.cod).startsWith('2')) {
    throw new Error(result.message || 'Unable to load reports');
  }
  return result;
}

async function requestHeaders() {
  const accessToken = await getAccessToken(User.VERITAS);
  const user = User.getUserInfo();

  const requestHeaders = new Headers();
  requestHeaders.append('Accept', 'application/json');
  requestHeaders.append('Content-Type', 'application/json');
  if (accessToken) {
    requestHeaders.append("jwtToken", `${accessToken}`);
    requestHeaders.append("email", `${user.email}`);
  }
  return requestHeaders;
}

export async function listAbuse(type, status, page, size) {
  const url = `${baseUrlAPI}/abuse/list/${type}/${status}?page=${page}&size=${size}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await handleAbuseResponse(response);
}

export async function searchAbuse(urlToFind, page = 0, size = 10) {
  const query = new URLSearchParams({ url: urlToFind.trim(), page, size });
  const response = await trackPromise(fetchWithTimeout(`${baseUrlAPI}/abuse/search?${query}`, {
    headers: await requestHeaders()
  }));
  const result = await handleAbuseResponse(response);
  if (!result || !Array.isArray(result.data) || !Number.isInteger(result.totalElements) ||
      !Number.isInteger(result.totalPages)) {
    throw new Error('Invalid report search response');
  }
  return result;
}

export async function getAbuse(id) {
  const url = `${baseUrlAPI}/abuse/specific/${id}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await handleAbuseResponse(response);
}

export async function classifyAbuse(urlToClassify, type) {
  const response = await trackPromise(fetchWithTimeout(`${baseUrlAPI}/abuse/classify`, {
    method: 'POST',
    headers: await requestHeaders(),
    body: JSON.stringify({ url: urlToClassify.trim(), type })
  }));
  const result = await handleAbuseResponse(response);
  if (!result || !result.data || result.data.type !== type || result.data.status !== 'accepted') {
    throw new Error('Invalid classification response');
  }
  return result;
}

export async function createAbuse(urls, type, apikey, userIp) {
  const user = User.getUserInfo();
  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');
  headers.append('apikey', apikey);
  headers.append("email", `${user.email}`);
  headers.append('user_ip', userIp);
  headers.append('type', type);  
  const url = `${baseUrlAPI}/abuse`;
  const response = await trackPromise(fetchWithTimeout(url, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({ urls })
  }));
  return await handleAbuseResponse(response);
}

export async function updateAbuse(hash, status) {
  const url = `${baseUrlAPI}/abuse/update/${hash}/${status}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    headers: await requestHeaders()
  }));
  return await handleAbuseResponse(response);
}

export async function deleteAbuse(id) {
  const url = `${baseUrlAPI}/abuse/delete/${id}`;
  const response = await trackPromise(fetchWithTimeout(url, {
    method: 'DELETE',
    headers: await requestHeaders()
  }));
  return await handleAbuseResponse(response);
}
